"use strict";

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//var $ = require('jquery'); 
var Util = function Util() {};

Util.prototype.extend = function (a, b) {
    for (var key in b) {
        if (b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
    return a;
};

Util.prototype.toggleFullscreen = function () {
    var element = document.documentElement;
    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        // Supports most browsers and their versions.
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    } else {
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
        if (requestMethod) {
            // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    }
};

// from http://www.quirksmode.org/js/events_properties.html#position
Util.prototype.getMousePos = function (e) {
    var posx = 0;
    var posy = 0;
    if (!e) var e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    } else if (e.clientX || e.clientY) {
        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return {
        x: posx,
        y: posy
    };
};

Util.prototype.getObjAttributesFromId = function (id, attributeName) {
    var properties = document.getElementById(id).getAttribute(attributeName).split('; ');
    var obj = {};
    properties.forEach(function (property) {
        var tup = property.split(':');
        obj[tup[0]] = tup[1];
    });

    return obj;
};

// from http://www.sberry.me/articles/javascript-event-throttling-debouncing
Util.prototype.throttle = function (fn, delay) {
    var allowSample = true;

    return function (e) {
        if (allowSample) {
            allowSample = false;
            setTimeout(function () {
                allowSample = true;
            }, delay);
            fn(e);
        }
    };
};

Util.prototype.capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

Util.prototype.getHost = function () {
    return '/' + window.location.pathname.split('/')[1] + '/';
};

Util.prototype.getFilenameFromUrl = function (path) {
    return path.replace(/^.*[\\\/]/, '');
};

Util.prototype.fromBytesToKbytes = function (value) {
    return Math.round(value / 1024);
};

Util.prototype.isExternalUrl = function (url) {
    return (/^https?:\/\//.test(url)
    );
};

Util.prototype.getDateYMDHIS = function (onlyYMD) {
    var today = new Date();
    var hours;
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    var now;

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    hours = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    today = yyyy + '/' + mm + '/' + dd;
    now = onlyYMD ? today : today + ' ' + hours;
    return now;
};

Util.prototype.replaceArray = function (find, replace, str) {
    for (var i = 0; i < find.length; i++) {
        str = str.replace(find[i], replace[i]);
    }
    return str;
};

Util.prototype.concatFrendlyUrl = function () /*str1,str2,...*/{
    var self = this;
    var args = Array.prototype.slice.call(arguments, 0);
    var result = args.reduce(function (pre, next) {
        return self.DoFriendlyUrl(pre) + '-' + self.DoFriendlyUrl(next);
    });
    return result;
};

Util.prototype.DoFriendlyUrl = function (str) {

    var find = ['Ñ', 'Ã', 'À', 'Á', 'Ä', 'Â', 'È', 'É', 'Ë', 'Ê', 'Ì', 'Í', 'Ï', 'Î', 'Ò', 'Ó', 'Ö', 'Ô', 'Ù', 'Ú', 'Ü', 'Û', 'ã', 'à', 'á', 'ä', 'â', 'è', 'é', 'ë', 'ê', 'ì', 'í', 'ï', 'î', 'ò', 'ó', 'ö', 'ô', 'ù', 'ú', 'ü', 'û', 'Ñ', 'ñ', 'Ç', 'ç', 'ñ'],
        replace = ['N', 'A', 'A', 'A', 'A', 'A', 'E', 'E', 'E', 'E', 'I', 'I', 'I', 'I', 'O', 'O', 'O', 'O', 'U', 'U', 'U', 'U', 'a', 'a', 'a', 'a', 'a', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'n', 'n', 'c', 'c', 'n'],
        url = '';
    str = this.replaceArray(find, replace, str);
    url = str.replace(/[^-A-Za-z0-9]+/g, '-').toLowerCase();

    return url;
};

Util.prototype.DoFriendlyUrlWichDate = function (str) {
    var url = this.DoFriendlyUrl(str);
    var date = this.getDateYMDHIS(true);
    return url + '-' + date.replace(/\//g, '-');
};

Util.prototype.scrollToAnchor = function (aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
};

Util.prototype.getDeltaScroll = function (e) {
    e.preventDefault();
    e = window.event || e;
    var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
    return delta;
};

Util.prototype.getCurrentUrlPart = function (position) {
    position = parseInt(position);
    var url = window.location.href;
    //for index 0
    position--;
    return url.split('/').filter(function (item) {
        return !(item === "" || item === "http:");
    })[position];
};

Util.prototype.getCurrentUrlFromPartTo = function (start, end) {
    var url = window.location.href;
    var array = url.split('/');

    if (!start) start = 0;
    if (!end) end = array.length - 1;
    end++;
    return array.filter(function (item) {
        return !(item === "" || item === "http:");
    }).slice(start, end).join("");
};

Util.prototype.runIfElapsedTime = function (callback, interval, righNow) {
    var lastCall = new Date().getTime();
    var executeFirsTime = righNow;

    return function (param) {
        var date = new Date();
        var now = date.getTime();

        if (executeFirsTime || now - lastCall > interval) {
            callback(param);
            lastCall = date.getTime();
            executeFirsTime = false;
        }
    };
};

Util.prototype.runIfCountTimes = function (callback, count) {
    var times = 1;
    return function () {
        var args = Array.prototype.slice.call(arguments, 0);
        if (count <= times) {
            callback.apply(null, args);times = 1;
        } else times++;
    };
};

Util.prototype.countDecimals = function (value) {
    if (value % 1 != 0) return value.toString().split(".")[1].length;
    return 0;
};

Util.prototype.ObjToArray = function (obj) {
    return $.map(obj, function (value, index) {
        return [value];
    });
};

Util.prototype.getExtensionFromStr = function (str) {
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(str)[1];

    return ext;
};

Util.prototype.showNotification = function ($el, message, className, duration) {
    $el.className = className;
    $el.text = message;
    $el.duration = duration || 3000;
    $el.open();
};

Util.prototype.uniquid = function (prefix) {
    var n = Math.floor(Math.random() * 11);
    var k = Math.floor(Math.random() * 1000000);
    var m = String.fromCharCode(n) + k;
    var result = prefix ? prefix + m : m;
    return result;
};

Util.prototype.ramdonFiveStrings = function (prefix) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    text = prefix ? prefix + text : text;
    return text;
};

Util.prototype.ramdonStrings = function (prefix, quantity) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < quantity; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    text = prefix ? prefix + text : text;
    return text;
};

Util.prototype.shuffleArray = function (arra1) {
    var ctr = arra1.length,
        temp,
        index;

    while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
    }
    return arra1;
};

Util.prototype.replaceAllStringOcurencies = function (source, search, replacement) {
    return source.replace(new RegExp(search, 'g'), replacement);
};

Util.prototype.redirect = function (url) {
    var host = this.getHost();
    url = 'http://' + window.location.host + host + url;
    window.open(url, '_blank');
};

Util.prototype.doNotAllowContentEditable = function () {
    $('body').find("*[contenteditable='true']").each(function () {
        $(this).attr('contenteditable', 'false');
    });
};

Util.prototype.objectIsset = function (obj) {
    return typeof obj !== 'undefined' && obj !== null;
};

Util.prototype.isKeyInObject = function (obj, key) {
    var res = (0, _keys2.default)(obj).some(function (v) {
        return v == key;
    });
    return res;
};

Util.prototype.setMultiModules = function (global, factory) {
    (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
};

Util.prototype.objRecursiveSome = function (obj, fn) {
    var result = false;

    for (var k in obj) {
        if (Array.isArray(obj[k]) && obj[k] !== null) {
            result = obj[k].some(function (element) {
                if (Array.isArray(element) === false && (typeof element === "undefined" ? "undefined" : (0, _typeof3.default)(element)) !== "object") {
                    return fn(element);
                }
                return this.objRecursiveSome(element, fn);
            }.bind(this));
        } else if ((0, _typeof3.default)(obj[k]) == "object" && obj[k] !== null) {
            result = this.objRecursiveSome(obj[k], fn);
        } else {
            result = fn(obj[k]);
        }
        if (result) break;
    }

    return result;
};

Util.prototype.getNumberRange = function (start, end, step) {
    var range = [];
    var typeofStart = typeof start === "undefined" ? "undefined" : (0, _typeof3.default)(start);
    var typeofEnd = typeof end === "undefined" ? "undefined" : (0, _typeof3.default)(end);

    if (step === 0) {
        throw TypeError("Step cannot be zero.");
    }

    if (typeofStart == "undefined" || typeofEnd == "undefined") {
        throw TypeError("Must pass start and end arguments.");
    } else if (typeofStart != typeofEnd) {
        throw TypeError("Start and end arguments must be of same type.");
    }

    typeof step == "undefined" && (step = 1);

    if (end < start) {
        step = -step;
    }

    if (typeofStart == "number") {

        while (step > 0 ? end >= start : end <= start) {
            range.push(start);
            start += step;
        }
    } else {
        throw TypeError("Only number types are supported");
    }

    return range;
};

Util.prototype.isEmpty = function (val) {

    return !/\S+/.test(val);
};

Util.prototype.resetForm = function (selectors) {
    selectors = selectors || ['input:text', 'textarea'];
    $('body').find(selectors.join(',')).val('');
};

Util.prototype.makeUrl = function () {
    var params = Array.prototype.slice.call(arguments);
    return params.filter(Boolean).reduce(function (a, b) {
        return a + b + '/';
    }, '');
};

Util.prototype.padChars = function (str, char, len, to) {
    if (!str || !char || this.length >= len) {
        return str;
    }
    to = to || 0;

    var max = (len - str.length) / char.length + 1;
    while (--max) {
        str = to ? str + char : char + str;
    }

    return str;
};

var evolUtil = new Util();

module.exports = evolUtil;


//////////////////
// WEBPACK FOOTER
// ./src/lib/rtveLab/rtveUtil.js
// module id = 294
// module chunks = 0